import { createFileRoute } from "@tanstack/react-router";
import { TopicsPage } from "@/projects/admin/pages/TopicsPage";

export const Route = createFileRoute("/admin/topics")({
  head: () => ({ meta: [{ title: "Topics — Admin" }] }),
  component: TopicsPage,
});
